import { openDB, type DBSchema, type IDBPDatabase } from 'idb';
import type { Snapshot } from '../api/types';

export interface OutboxItem {
  submissionId: string;         // primary key (UUID) — also the server idempotency key
  createdAt: string;            // ISO, when queued
  clientCapturedAt: string;     // ISO, best server-time estimate at capture
  tagCode: string;
  equipmentName: string;
  location: string;
  operatorId: string;
  operatorName: string;
  values: Record<string, number | string>;
  remarks: string;
  confirmedAbnormal: boolean;
  status: 'pending' | 'syncing' | 'synced' | 'rejected';
  attempts: number;
  lastError?: string;
  rejectReason?: string;
}

interface LogbookDB extends DBSchema {
  outbox: { key: string; value: OutboxItem };
  kv: { key: string; value: unknown };
}

let dbp: Promise<IDBPDatabase<LogbookDB>> | null = null;

export function db(): Promise<IDBPDatabase<LogbookDB>> {
  if (!dbp) {
    dbp = openDB<LogbookDB>('logbook', 1, {
      upgrade(d) {
        if (!d.objectStoreNames.contains('outbox')) d.createObjectStore('outbox', { keyPath: 'submissionId' });
        if (!d.objectStoreNames.contains('kv')) d.createObjectStore('kv');
      },
    });
  }
  return dbp;
}

export async function kvGet<T>(key: string): Promise<T | undefined> {
  return (await db()).get('kv', key) as Promise<T | undefined>;
}
export async function kvSet(key: string, value: unknown): Promise<void> {
  await (await db()).put('kv', value, key);
}

export async function saveSnapshot(s: Snapshot): Promise<void> {
  await kvSet('snapshot', s);
}
export async function loadSnapshot(): Promise<Snapshot | undefined> {
  return kvGet<Snapshot>('snapshot');
}
